import { render, staticRenderFns } from "./SearchNoResults.vue?vue&type=template&id=13919a13"
import script from "./SearchNoResults.vue?vue&type=script&lang=js"
export * from "./SearchNoResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports